import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rangeButton", "typeButton"]
  static values = {
    activity: Object
  }

  connect() {
    this.currentRange = "week"
    this.currentType = this.getDefaultType()
  }

  getDefaultType() {
    // Check entity-available types by seeing which keys exist in activity data
    // Use the rangeButton label to infer since all keys always exist as empty arrays,
    // instead read the typeButton's current displayed text
    const typeSpan = this.typeButtonTarget.querySelector("span:nth-child(2)")
    const label = typeSpan ? typeSpan.textContent.trim() : ""
    if (label === "Game Recaps") return "game_recaps"
    if (label === "Feature Stories") return "feature_stories"
    if (label === "Player Bios") return "player_bios"
    if (label === "Online Interviews") return "online_interviews"
    return "game_recaps"
  }

  updateRange(event) {
    event.preventDefault()
    const range = event.currentTarget.dataset.range
    const label = event.currentTarget.dataset.label
    this.currentRange = range
    this.rangeButtonTarget.innerHTML = `
      <span style="color: var(--fanword-text);">Range:</span>
      <span style="color: var(--fanword-black); font-weight: 500;">
        ${label}
      </span>
      <i class="fas fa-angle-down ms-1" style="color: var(--fanword-text);"></i>
    `
    this.updateChart()
  }

  updateType(event) {
    event.preventDefault()
    const type = event.currentTarget.dataset.type
    const label = event.currentTarget.dataset.label
    this.currentType = type
    this.typeButtonTarget.innerHTML = `
      <span style="color: var(--fanword-text);">Type:</span>
      <span style="color: var(--fanword-black); font-weight: 500;">
        ${label}
      </span>
      <i class="fas fa-angle-down ms-1" style="color: var(--fanword-text);"></i>
    `
    this.updateChart()
  }

  updateChart() {
    const activity = this.activityValue
    const allDates = activity.dates || []
    const allTypeData = activity[this.currentType] || []

    const rangeDays = { week: 7, month: 30, three_months: 90 }
    const days = rangeDays[this.currentRange] || 7

    const dates = allDates.slice(-days)
    const typeData = allTypeData.slice(-days)

    const chartData = {}

    dates.forEach((date, index) => {
      const [year, month, day] = date.split("-")
      const dateObj = new Date(year, month - 1, day)

      const m = dateObj.getMonth() + 1
      const d = dateObj.getDate()

      const label = `${m}/${d}`
      chartData[label] = typeData[index] || 0
    })

    const chart = Chartkick.charts['analytics_activity_chart']

    if (chart) {
      chart.updateData(chartData)
    }
  }
}